export default {
    notification_type: {
        OPERATION_STATUS_CHANGE: 'Cambio de estado en operación',
        ACCOUNT_STATUS_CHANGE: 'Cambio de estado en cuenta',
        KNOWLEDGE_TEST: 'Test de Conocimiento',
        DOCUMENT_EXPIRATION: 'Su documento de identidad expirará próximamente',
        DOCUMENT_EXPIRED_ONE_MONTH: 'Su documento de indentidad expiró hace un mes',
        DOCUMENT_EXPIRED_THREE_MONTHS: 'Su documento de identidad expiró hace tres meses',
        REFRESH_VIDEO_ID_EMAIL: 'Videoidentificación rechazada',
        IIGG_READY: 'Ya tiene disponible el informe de gastos',
        IIFF_FI_READY: 'Ya tiene disponible el informe fical de su cuenta',
        IIFF_PP_READY: 'Ya tiene disponible el informe fical de su cuenta',
        MINOR_EXPIRATION: 'El titular de la cuenta pasará a ser mayor de edad',
        MISSING_CCC_DOCUMENT: 'Documento de cuenta corriente pendiente',
        SUSCRIPTION_TRANSFER_DETAILS: 'Datos para realizar la transferencia',
        DOCUMENTATION_ISSUE_CREATED: 'Solicitud de nueva documentación'
    }
};
